import React, { type FunctionComponent } from 'react'

type Props = {
  validationErrors: ExternalLocationValidationErrorsType
}

export const ExternalLocationValidationError: FunctionComponent<Props> = ({ validationErrors }) => {
  const { duplicateIds, linesWithWrongColumnCount, linesWithMissingRequiredValues, linesWithIllegalPositionValues } =
    validationErrors

  return (
    <ul className="ml-4 list-disc">
      {duplicateIds.length > 0 && <li className="px-2">Duplicate ids on row {duplicateIds.join(', ')}</li>}

      {linesWithIllegalPositionValues.length > 0 && (
        <li className="px-2">Invalid coordinates on row {linesWithIllegalPositionValues.join(', ')}</li>
      )}

      {linesWithMissingRequiredValues.length > 0 && (
        <li className="px-2">Missing required fields on row {linesWithMissingRequiredValues.join(', ')}</li>
      )}

      {linesWithWrongColumnCount.length > 0 && (
        <li className="px-2">Missing columns on row {linesWithWrongColumnCount.join(', ')}</li>
      )}
    </ul>
  )
}
